import React from 'react';
import {
  Paper,
  Typography,
  Box,
  useTheme
} from '@mui/material';

export const QuizModeCard = ({ value, icon, title, description, selected, onClick }) => {
  const theme = useTheme();
  
  return (
    <Paper 
      elevation={selected ? 3 : 1}
      sx={{ 
        p: 2,
        cursor: 'pointer',
        height: '100%',
        transition: 'all 0.3s ease',
        transform: selected ? 'scale(1.02)' : 'scale(1)',
        border: selected ? `2px solid ${theme.palette.primary.main}` : '1px solid',
        borderColor: selected ? theme.palette.primary.main : theme.palette.divider,
        '&:hover': {
          transform: 'scale(1.02)',
          boxShadow: theme.shadows[4]
        }
      }}
      onClick={() => onClick(value)}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {React.cloneElement(icon, { 
          color: selected ? 'primary' : 'action',
          sx: { fontSize: 28 }
        })}
        <Typography variant="h6" sx={{ ml: 1, color: selected ? 'primary.main' : 'text.primary' }}>
          {title}
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Paper>
  );
};

export const StatCard = ({ title, value, icon, color = 'primary' }) => {
  const theme = useTheme();
  
  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        height: '100%',
        bgcolor: theme.palette.mode === 'dark' 
          ? theme.palette.grey[800] 
          : theme.palette.grey[50],
        border: `1px solid ${theme.palette.divider}`
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {React.cloneElement(icon, { color, sx: { fontSize: 28 } })}
        <Typography variant="h6" sx={{ ml: 1 }}>
          {title}
        </Typography>
      </Box>
      <Typography variant="h4" color={`${color}.main`}>
        {value}
      </Typography>
    </Paper>
  );
}; 